// src/redux/reducers/ComCatRecruiteReducer.js

import {
    FETCH_COMPANY_SIZE_REC_REQUEST,
    FETCH_COMPANY_SIZE_REC_SUCCESS,
    FETCH_COMPANY_SIZE_REC_FAILURE,
    SET_SELECTED_COMPANY_REC_SIZE,
} from '../types';

const initialState = {
    loading: false,
    companyCategories: [],
    selectedCategoryId: null,
    error: '',
};

const ComCatRecruiteReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_COMPANY_SIZE_REC_REQUEST:
            return { ...state, loading: true };
        case FETCH_COMPANY_SIZE_REC_SUCCESS:
            return { ...state, loading: false, companyCategories: action.payload, error: '' };
        case FETCH_COMPANY_SIZE_REC_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case SET_SELECTED_COMPANY_REC_SIZE:
            return { ...state, selectedCategoryId: action.payload };
        default:
            return state;
    }
};

export default ComCatRecruiteReducer;
